import { Grid, Box } from '@mui/material';
import isEmpty from 'lodash-es/isEmpty';
import { useState, useEffect } from 'react';
import {
  searchBots,
  IHarvestBotSearch,
  IHarvestBotDownloadMatched,
  IHarvestBotDownloadMatchedCandidate,
} from 'wisestep-api';
import {
  ScrollableTabs,
  TabTextVariant,
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsColors,
} from 'wisestep-base';

import CareerBuilderBotDownloadMatchCard from '../careerbuilder/components/CareerBuilderBotDownloadMatchCard';
import CareerBuilderEdgeBotDownloadMatchCard from '../careerbuilderedge/components/CareerBuilderEdgeBotDownloadMatchCard';
import DiceBotDownloadMatchCard from '../dice/components/DiceBotDownloadMatchCard';
import TechFetchDownloadMatchCard from '../techfetch/components/TechFetchBotDownloadMatchCard';

const harvestBotTabsList = [
  {
    tabName: 'Matched',
    type: 'all',
  },
  {
    tabName: 'Download',
    type: 'downloaded',
  },
];

const HarveDownloadMatchList = ({ type, harvestId, onViewCvClick, jobBoardName }) => {
  /** State  Definations And Constant Values*/
  const selectedTabIndex = harvestBotTabsList.findIndex((hb) => hb.type === type);
  const [tabValue, setTabValue] = useState<string>(type);
  const [matchedList, setMatchedList] = useState<IHarvestBotDownloadMatched[]>([]);
  const [downloadList, setDownloadList] = useState<IHarvestBotDownloadMatchedCandidate[]>([]);

  /**  Hooks Events */
  useEffect(() => {
    const harvestBots: IHarvestBotSearch = {
      harvestingId: harvestId,
      paginationState: '',
      recordType: tabValue,
    };
    const getHarvestBotEvent = async () => {
      const response = await searchBots(harvestBots);
      if (tabValue === 'all') setMatchedList(response?.data?.runs);
      else setDownloadList(response?.data?.records);
    };
    getHarvestBotEvent();
  }, [tabValue, harvestId]);

  /** Hooks Events */

  const candidateCard = (candidate: IHarvestBotDownloadMatchedCandidate, indexchild) => (
    <Grid key={indexchild} style={{ background: WsColors.BackGround }}>
      {jobBoardName == 'DICE_SEARCH' && (
        <DiceBotDownloadMatchCard
          onViewCvClick={onViewCvClick}
          candidate={JSON.parse(candidate.candidateRecord)}
          createdOn={candidate.createdOn}
          candidateId={candidate.candidateId}
        />
      )}

      {jobBoardName == 'TECH_FETCH' && (
        <TechFetchDownloadMatchCard
          onViewCvClick={onViewCvClick}
          candidate={JSON.parse(candidate.candidateRecord)}
          createdOn={candidate.createdOn}
          candidateId={candidate.candidateId}
        />
      )}

      {jobBoardName == 'CAREER_BUILDER_EDGE' && (
        <CareerBuilderEdgeBotDownloadMatchCard
          onViewCvClick={onViewCvClick}
          candidate={JSON.parse(candidate.candidateRecord)}
          createdOn={candidate.createdOn}
          candidateId={candidate.candidateId}
        />
      )}

      {jobBoardName == 'CAREER_BUILDER' && (
        <CareerBuilderBotDownloadMatchCard
          onViewCvClick={onViewCvClick}
          candidate={JSON.parse(candidate.candidateRecord)}
          createdOn={candidate.createdOn}
          candidateId={candidate.candidateId}
        />
      )}
    </Grid>
  );

  return (
    <>
      <Grid>
        <Grid>
          <ScrollableTabs
            scrollList={harvestBotTabsList}
            defaultValue={selectedTabIndex}
            getTabIndex={(index: number) => {
              setTabValue(harvestBotTabsList[index].type);
            }}
            variant={TabTextVariant.SUB_TITLE}
          />
        </Grid>
        <Grid>
          {matchedList &&
            tabValue === 'all' &&
            matchedList.map((run: any, index) => (
              <Box px={2} py={1} mt={2} key={index}>
                <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
                  Run # {run.runNumber}
                </WsTypography>

                {!isEmpty(run.records) ? (
                  run.records.map((candidate: IHarvestBotDownloadMatchedCandidate, indexchild) =>
                    candidateCard(candidate, indexchild)
                  )
                ) : (
                  <WsTypography variant={WsTypoVariants.SUB_TITLE} color={WsTypoColors.BLACK}>
                    No Candidate Found
                  </WsTypography>
                )}
              </Box>
            ))}
          {downloadList &&
            tabValue === 'downloaded' &&
            downloadList.map((candidate: IHarvestBotDownloadMatchedCandidate, indexchild) =>
              candidateCard(candidate, indexchild)
            )}
        </Grid>
      </Grid>
    </>
  );
};
export default HarveDownloadMatchList;
